import { z } from "zod";

import {
  researchDescribeSourceInputSchema,
  researchFindSourceInputSchema,
  researchFindSourceResultSchema,
  researchGetJobInputSchema,
  researchJobEnvelopeSchema,
  researchRunSourceInputSchema,
  researchSourceDescriptionSchema,
} from "../../research";

// Metadata for the four `research_*` MCP tools in apps/bedrock-api/src/mcp/research-tools.ts.
export const knownResearchMcpToolMetadataRegistrySchema = z
  .object({
    research_find_source: z.object({
      iconKey: z.literal("research"),
      input: researchFindSourceInputSchema,
      output: researchFindSourceResultSchema,
    }),
    research_describe_source: z.object({
      iconKey: z.literal("research"),
      input: researchDescribeSourceInputSchema,
      output: researchSourceDescriptionSchema,
    }),
    research_run_source: z.object({
      iconKey: z.literal("research"),
      input: researchRunSourceInputSchema,
      output: researchJobEnvelopeSchema,
    }),
    research_get_job: z.object({
      iconKey: z.literal("research"),
      input: researchGetJobInputSchema,
      output: researchJobEnvelopeSchema,
    }),
  })
  .describe("KnownResearchMcpToolMetadataRegistry");
